// Copyright 2026 Hardfin, Inc.
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { z } from 'zod';

const validationErrorFieldSchema = z.object({
  fieldName: z.string(),
  error: z.string(),
  errorCode: z.number(),
});

const processedMoveImportDataSchema = z.object({
  serial: z.string(),
  index: z.number(),
  assetKey: z.string(),
  aegKey: z.string(),
  originName: z.string(),
  destinationName: z.string(),
  errors: z.array(validationErrorFieldSchema),
});

const rowValidationErrorSchema = z.object({
  index: z.number(),
  errors: z.array(validationErrorFieldSchema),
});

export const uploadMoveDataResponseSchema = z.object({
  data: z.object({
    success: z.boolean(),
    items: z.array(processedMoveImportDataSchema),
    structureErrors: z.array(validationErrorFieldSchema),
    rowErrors: z.array(rowValidationErrorSchema),
  }),
});

export type MoveUploadResult = z.infer<
  typeof uploadMoveDataResponseSchema
>['data'];

export async function uploadMoveData(
  formData: FormData
): Promise<MoveUploadResult> {
  const url = '/v1/import/move-data';
  const response = await api.post(url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  const parsed = await parseResponse(
    uploadMoveDataResponseSchema,
    response.data,
    {
      schemaName: 'UploadMoveData',
      endpoint: url,
    }
  );
  return parsed.data;
}
